<script lang="ts">
    import KpResponsiveGenericTable from './KpResponsiveGenericTable.svelte';
    import type {DataDisplayerSettings} from '../../../typings/portaro.fe.types';
    import {DataDisplayerOptions} from '../../../typings/portaro.fe.types';
    import {createEventDispatcher, getContext, onMount} from 'svelte';
    import type {LocalizeFunction} from '../../../svelte/types';
    import {LOCALIZE_KEY} from '../../../svelte/utils';
    import type {Identified} from '../../../typings/portaro.be.types';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);

    const dispatch = createEventDispatcher();

    const defaultSettings = {
        options: [],
        columnsSetting: [],
    } as DataDisplayerSettings;

    export let settings = defaultSettings;

    let originalData = [] as Identified<number | string>[];

    onMount(async () => {
        await loadAll();
    })

    export const loadAll = async () => {
        originalData = await settings.loadAll();
    };

    const isBoolean = (value) => {
        return typeof value === 'boolean';
    }

    const deleteItem = (index) => {
        dispatch('delete', originalData[index]);
    };

    const editItem = (index) => {
        dispatch('edit', originalData[index])
    };

    $: viewData = originalData.map((value) => {
        const newValue = {};
        Object.keys(columnByKey).forEach((key) => {
            if (columnByKey[key] && typeof columnByKey[key].valueModifier === 'function' && value[key] !== null) {
                newValue[key] = columnByKey[key].valueModifier(value[key]);
            } else {
                newValue[key] = value[key];
            }
        })
        return newValue;
    }) as Identified<number | string>[];

    $: columnByKey = settings.columnsSetting.reduce((obj, item) => Object.assign(obj, { [item.key]: item }), {});
</script>

<KpResponsiveGenericTable bordered={false} hoverRows={true} stripedRows={false} condensed={false}>
    <slot slot="header">
        {#if Array.isArray(settings.columnsSetting)}
            <tr>
                {#each settings.columnsSetting as columnSetting}
                    <td>
                        {columnSetting.title}
                    </td>
                {/each}
                {#if (Array.isArray(settings.options) && settings.options.length)}
                    <th>
                        {localize( /* @kp-localization commons.edit */ 'commons.edit')}
                    </th>
                {/if}

            </tr>
        {/if}
    </slot>
    <slot slot="body">
        {#if Array.isArray(viewData)}
            {#each viewData as data, index (data.id)}
                <tr>
                    {#each Object.entries(data) as [, value]}
                        {#if isBoolean(value)}
                            <td><span class:hidden={!value} class="glyphicon glyphicon-ok"></span></td>
                        {:else}
                            <td>{value ?? ''}</td>
                        {/if}
                    {/each}
                    {#if (Array.isArray(settings.options) && settings.options.length)}
                        <td>
                            {#if settings.options.includes(DataDisplayerOptions.Edit)}
                                <button type="button" on:click={() => editItem(index)} class="btn btn-default btn-xs">{localize( /* @kp-localization commons.edit */ 'commons.edit')}</button>
                            {/if}
                            {#if settings.options.includes(DataDisplayerOptions.Delete)}
                                <button type="button" on:click={() => deleteItem(index)} class="btn btn-default btn-xs">{localize( /* @kp-localization commons.Smazat */ 'commons.Smazat')}</button>
                            {/if}
                        </td>
                    {/if}
                </tr>
            {/each}
        {/if}
    </slot>
    <slot slot="footer"></slot>
</KpResponsiveGenericTable>